import { ref } from 'vue';
import type { CustomerProfile } from '@/components/dashboard/Customer360.vue';
import { findCustomer } from '@/data/customer-profiles';

/**
 * Globalny store dla Customer360 slide-over.
 * Otwierany z dowolnego widoku (Sales, Pipeline, Activity, Reports).
 *
 * Usage:
 *   const { openCustomer } = useCustomer360();
 *   openCustomer('Tomasz Nowak');
 *
 * Slide-over panel zarejestrowany w App.vue (singleton).
 */

const currentProfile = ref<CustomerProfile | null>(null);
const isOpen = ref(false);

export function useCustomer360() {
  function openCustomer(name: string) {
    currentProfile.value = findCustomer(name);
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return {
    currentProfile,
    isOpen,
    openCustomer,
    close,
  };
}
